import { render, staticRenderFns } from "./header-sort.vue?vue&type=template&id=399c2136&scoped=true&"
import script from "./header-sort.vue?vue&type=script&lang=js&"
export * from "./header-sort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399c2136",
  null
  
)

export default component.exports